<template>
  <div id="salesmanList" v-loading="exportLoading">
    <el-card>
      <!-- 查询选项 -->
      <Form class="salesmanForm" :label-width="160">
        <FormItem class="form_item" :label="$t('reportMonth')">
          <el-date-picker v-model="reportMonth" :editable="false" :clearable="false" type="month" value-format="yyyy-MM" :placeholder="$t('select')"></el-date-picker>
        </FormItem>
        <div class="buttonDiv">
          <el-button type="primary" size="mini" icon="el-icon-search" @click="searchReport">{{$t('search')}}</el-button>
          <!-- <el-button type="primary" size="mini" icon="el-icon-download" @click="exportExcel">{{$t('export')}}</el-button> -->
        </div>
      </Form>
      <div class="contentTableDiv">
        <el-table :data="tableData" border style="width:100%" tooltip-effect="dark" :header-cell-style="{background:'#F5F5F9'}">
          <el-table-column prop="empName" :label="$t('name')" align="center" :show-overflow-tooltip="true" min-width="150"></el-table-column>
          <el-table-column prop="empCode" :label="$t('empCode')" align="center" :show-overflow-tooltip="true" min-width="80"></el-table-column>
          <el-table-column prop="userLocation" :label="$t('userLocation')" align="center" :show-overflow-tooltip="true" min-width="80"></el-table-column>
          <el-table-column prop="holidayDays" :label="$t('holidayDays')" align="center" :show-overflow-tooltip="true" min-width="180" ></el-table-column>
          <el-table-column prop="workDays" :label="$t('workDays')" align="center" :show-overflow-tooltip="true" min-width="150" ></el-table-column>
          <el-table-column prop="standardHours" :label="$t('standardHours')" align="center" :show-overflow-tooltip="true" min-width="190" ></el-table-column>
          <el-table-column prop="saturatedHours" :label="$t('saturatedHours')" align="center" :show-overflow-tooltip="true" min-width="190" ></el-table-column>
          <el-table-column prop="workHours" :label="$t('labourHours')" align="center" :show-overflow-tooltip="true" min-width="110" ></el-table-column>
          <el-table-column prop="saturationPercent" :label="$t('saturationPercent')" align="center" :show-overflow-tooltip="true" min-width="180" ></el-table-column>
        </el-table>
      </div>
      <div class="pageDiv">
        <el-pagination small @size-change="changePageSize" @current-change="changePage" :current-page="currentPage" :page-sizes="[10, 20,50,100]"
          :page-size="pageSize" layout="total, prev, pager, next, sizes, jumper" :total="totalCount">
        </el-pagination>
      </div>
    </el-card>
    <el-card>
      <div class="contentTableDiv">
        <el-table :data="financialData" border style="width:100%" tooltip-effect="dark" :header-cell-style="{background:'#F5F5F9'}">
          <el-table-column prop="empName" :label="$t('name')" align="center" :show-overflow-tooltip="true" min-width="150"></el-table-column>
          <el-table-column prop="empCode" :label="$t('empCode')" align="center" :show-overflow-tooltip="true" min-width="80"></el-table-column>
          <el-table-column prop="workHours" :label="$t('labourHours')" align="center" :show-overflow-tooltip="true" min-width="120" ></el-table-column>
          <el-table-column prop="marketFee" :label="$t('marketFee')" align="center" :show-overflow-tooltip="true" min-width="240"></el-table-column>
          <el-table-column prop="marketPercent" :label="$t('marketPercent')" align="center" :show-overflow-tooltip="true" min-width="210" ></el-table-column>
          <el-table-column prop="contractFee" :label="$t('contractFee')" align="center" :show-overflow-tooltip="true" min-width="250" ></el-table-column>
          <el-table-column prop="contractPercent" :label="$t('contractPercent')" align="center" :show-overflow-tooltip="true" min-width="220" ></el-table-column>
          <el-table-column prop="warrantyFee" :label="$t('warrantyFee')" align="center" :show-overflow-tooltip="true" min-width="190" ></el-table-column>
          <el-table-column prop="warrantyPercent" :label="$t('warrantyPercent')" align="center" :show-overflow-tooltip="true" min-width="170" ></el-table-column>
          <el-table-column prop="serviceFee" :label="$t('serviceFee')" align="center" :show-overflow-tooltip="true" min-width="230" ></el-table-column>
          <el-table-column prop="servicePercent" :label="$t('servicePercent')" align="center" :show-overflow-tooltip="true" min-width="210" ></el-table-column>
          <el-table-column prop="generalFee" :label="$t('generalFee')" align="center" :show-overflow-tooltip="true" min-width="220" ></el-table-column>
          <el-table-column prop="generalPercent" :label="$t('generalPercent')" align="center" :show-overflow-tooltip="true" min-width="200" ></el-table-column>
        </el-table>
      </div>
      <div class="pageDiv">
        <el-pagination small @size-change="changeFinancialPageSize" @current-change="changeFinancialPage" :current-page="currentFinancialPage" 
            :page-sizes="[10, 20,50,100]" :page-size="pageFinancialSize" layout="total, prev, pager, next, sizes, jumper" :total="totalFinancialCount">
        </el-pagination>
      </div>
    </el-card>

  </div>
</template>
<script>
    import * as validate from '@/utils/validate'

    export default {
        name: 'engineerReport',
        created () {
          this.searchReport();
        },
        data () {
          return {
            reportMonth:this.timeFormat(new Date()),
            //other
            exportLoading:false,
            currentPage: 1,
            totalCount: 0,
            pageSize: 10,
            tableData: [],
            currentFinancialPage: 1,
            totalFinancialCount: 0,
            pageFinancialSize: 10,
            financialData: [],
          }
        },
        methods: {
          getTotalLabourReport(){
            let url = `${this.$store.state.islhurl}getTotalLabourReport/${this.pageSize}/${this.currentPage}`
            let pm = {
              reportMonth : this.reportMonth,
              labourStatus : 'engineer',
              islhToken : sessionStorage.getItem('islhtoken'),
            }
            // console.log(pm)
            this._post(url,pm).then(
              res =>{
                this.tableData = res.data;
                this.totalCount = res.totalNums;
              }
            )
          },
          getLabourFinancialReport(){
            let url = `${this.$store.state.islhurl}getLabourFinancialReport/${this.pageFinancialSize}/${this.currentFinancialPage}`
            let pm = {
              reportMonth : this.reportMonth,
              labourStatus : 'engineer',
              islhToken : sessionStorage.getItem('islhtoken'),
            }
            this._post(url,pm).then(
              res =>{
                this.financialData = res.data;
                this.totalFinancialCount = res.totalNums;
              }
            )
          },
          searchReport(){
            this.pageSize = 10;
            this.currentPage = 1;
            this.getTotalLabourReport();
            this.pageFinancialSize = 10;
            this.currentFinancialPage = 1;
            this.getLabourFinancialReport();
          },
          exportExcel(){
            this.exportLoading = true;
            let execlName = 'LabourHourReport.xlsx';
            this.$axios({
              url: `${this.$store.state.islhurl}labourReport/exportReport`,
              method: 'post',
              data: {
                reportMonth : this.reportMonth,
                labourStatus : 'engineer',
                islhToken : sessionStorage.getItem('islhtoken'),
              },
              responseType:"blob"
            }).then(response=>{
              this.exportLoading = false;
              const blob = new Blob([response.data])
              const aEle = document.createElement('a'); // 创建a标签
              const href = window.URL.createObjectURL(blob); // 创建下载的链接
              aEle.href = href;
              aEle.download = execlName; // 下载后文件名
              document.body.appendChild(aEle);
              aEle.click();     // 点击下载 
              document.body.removeChild(aEle); // 下载完成移除元素
              window.URL.revokeObjectURL(href) // 释放掉blob对象
            })
          },
          changePage (val) {
            this.currentPage = val;
            this.getTotalLabourReport();
          },
          // 改变当前页显示条数
          changePageSize (val) {
            this.pageSize = val;
            this.getTotalLabourReport();
          },
          changeFinancialPage (val) {
            this.currentFinancialPage = val;
            this.getLabourFinancialReport();
          },
          // 改变当前页显示条数
          changeFinancialPageSize (val) {
            this.pageFinancialSize = val;
            this.getLabourFinancialReport();
          },
          timeFormat (time) {
            if(time == null || time == ""){
              return null;
            }
            const dateTime = new Date(time);
            const year = dateTime.getFullYear();
            const month = dateTime.getMonth() + 1;
            return year + "-" +this.addZero(month);
          },
          addZero (v) {
            return v < 10 ? '0' + v : v;
          }
        },
    }
</script>



// WEBPACK FOOTER //
// src/view/report/engineerReport.vue